export default "__VITE_ASSET__DdIYSWN$__"